import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Heart } from "lucide-react";
import { cPath } from "../../constants";
import { formatDiscountOff } from "../../utils/offerDisplay";

const H1 = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
`;

const Row = styled(Link)`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  margin-bottom: 0.75rem;
  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.cardMd};
  }
`;

const Empty = styled.p`
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  font-size: 0.9375rem;
`;

export default function DashboardLiked() {
  const { isAuthenticated } = useSelector((s) => s.auth);
  const { likedCoupons } = useSelector((s) => s.couponLike);

  const rows = likedCoupons.map((c) => ({
    id: c.id,
    couponId: c.id,
    storeName: c.storeName,
    storeLogo: c.storeLogo,
    title: c.title,
    discountValue: formatDiscountOff(c) || (c.type === "deal" ? "Get Deal" : "—"),
  }));

  if (!isAuthenticated) {
    return (
      <div>
        <H1>Liked Coupons</H1>
        <Empty>Sign in to see liked coupons.</Empty>
      </div>
    );
  }

  return (
    <div>
      <H1>Liked Coupons</H1>
      {rows.length === 0 && (
        <Empty>No liked coupons yet. Save some from a deal page when logged in.</Empty>
      )}
      {rows.map((item) => (
        <Row key={item.id} to={cPath(`coupon/${item.couponId}`)}>
          <img
            src={item.storeLogo}
            alt=""
            style={{ width: 40, height: 40, borderRadius: 4, objectFit: "contain" }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ margin: 0, fontSize: "0.875rem", fontWeight: 600 }}>{item.title}</p>
            <span style={{ fontSize: "0.75rem", color: "hsl(220 10% 46%)" }}>
              {item.storeName}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
            <span style={{ fontWeight: 700, color: "hsl(221 67% 44%)" }}>{item.discountValue}</span>
            <Heart size={16} fill="hsl(348 60% 35%)" color="hsl(348 60% 35%)" />
          </div>
        </Row>
      ))}
    </div>
  );
}
